export const COLECCION_URL = "prueba";
export const COLECCION_PAGOS = "pagos";
export const COLECCION_COBROLOCAL = "cobrolocal";

// export const API = "https://api.vallejosmateriales.com.ar";

export const API = "https://serverless.vallejosmateriales.com.ar";
